<template>
  <div>
    <van-submit-bar :price="amount" button-text="提交订单" class="submit-bar" @submit="onSubmit">
      <van-checkbox icon-size="18px" checked-color="#F40442" v-model="checked">全选</van-checkbox>
    </van-submit-bar>
    <!--<div class="submit-bar-placeholder" style="width:100%;height:50px"></div>-->
  </div>
</template>

<script>
  export default {
    props: {
      amount: {
        type: Number,
        default: 0
      },
      value: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      checked: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        }
      }
    },
    methods: {
      onSubmit() {
        this.$emit('submitOrder')
      }
    }
  }
</script>

<style scoped>
  .submit-bar {
    box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.08);
    bottom: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/views/cart/modules/Footer.vue